import React, {useEffect, useState} from 'react';
import {IconButton, Theme} from '@mui/material';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import AppScrollbar from '../AppScrollbar';
import IntlMessages from '@crema/helpers/IntlMessages';
import NotificationItem from './NotificationItem';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {SxProps} from '@mui/system';
import {useAppDispatch} from 'toolkit/hooks';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
} from '@crema/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth';

type AppNotificationContentProps = {
  onClose: () => void;
  sxStyle: SxProps<Theme>;
};

const AppNotificationContent: React.FC<AppNotificationContentProps> = ({
  onClose,
  sxStyle,
}) => {
  const dispatch = useAppDispatch();
  const [getNotification, SetGetNotification] = useState([]);

  const FetchNotification = async () => {
    try {
      dispatch({type: FETCH_START});
      const {data} = await jwtAxios.get(`notifications/getMine`);
      dispatch({type: FETCH_SUCCESS});
      SetGetNotification(data.data || []);
      // console.log('data =>XXX', data);
    } catch (error: any) {
      dispatch({type: FETCH_ERROR, payload: error.response.data.message});
    }
  };

  useEffect(() => {
    FetchNotification();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 450,
        height: '110%',
        ...sxStyle,
      }}
    >
      <Box
        sx={{
          padding: '5px 20px',
          display: 'flex',
          alignItems: 'center',
          borderBottom: 1,
          borderBottomColor: (theme) => theme.palette.divider,
          minHeight: {xs: 56, sm: 70},
        }}
      >
        <Typography component='h3'>
          <IntlMessages id='common.notifications' />({getNotification?.length})
        </Typography>
        <IconButton
          sx={{
            height: 40,
            width: 40,
            marginLeft: 'auto',
            color: 'text.secondary',
          }}
          onClick={onClose}
          size='large'
        >
          <CancelOutlinedIcon />
        </IconButton>
      </Box>
      {getNotification.length > 0 ? (
        <AppScrollbar
          sx={{
            height: {xs: 'calc(100% - 96px)', sm: 'calc(100% - 110px)'},
          }}
        >
          <List sx={{py: 0}}>
            {getNotification.map((item) => (
              <NotificationItem key={item.id} item={item} />
            ))}
          </List>
        </AppScrollbar>
      ) : (
        <Typography
          sx={{
            pt: '32px',
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 900,
            color: 'text.secondary',
          }}
        >
          Notification not found
        </Typography>
      )}
      {/* <Button
        sx={{
          borderRadius: 0,
          width: '100%',
          textTransform: 'capitalize',
          marginTop: 'auto',
          height: 40,
        }}
        variant='contained'
        color='primary'
      >
        <IntlMessages id='common.viewAll' />
      </Button> */}
    </Box>
  );
};

export default AppNotificationContent;
